import React from 'react';

const Svg = (props) => (
  <svg {...props} viewBox="0 0 1478 1024" width="288.671875" height="200"><path d="M939.59085464 431.041155L765.84356164 642.495307c-8.132852 11.090253-24.398556 14.047653-35.488808 5.175451-2.218051-1.4787-3.696751-2.957401-5.175452-5.175451L550.69265964 431.041155c-8.872202-10.350903-11.090253-24.398556-6.654152-36.967509 3.696751-12.568953 14.787004-21.441155 27.355957-22.919855h347.494585c12.568953 1.4787 23.659206 10.350903 27.355956 22.919855 4.436101 12.568953 2.218051 26.616606-6.654151 36.967509z" fill="currentColor"></path></svg>
);

export default Svg;
